import React, { useEffect, useState } from 'react';
import ProMarketingLink from './ProMarketingLink';
import { useTranslation } from 'react-i18next';

/** Logos partenaires marketing (LP V2 / métiers / hubs marché). */
export const MARKETING_PARTNERS: { name: string; logo: string; route: string }[] = [
  { name: 'Osmoz Academy', logo: '/partners/osmoz-academy.jpeg', route: '/partenaires/osmoz' },
  { name: 'Lupi', logo: '/partners/lupi-white.png', route: '/partenaires/lupi' },
  { name: 'Mediavet', logo: '/partners/mediavet.png', route: '/partenaires/mediavet' },
  { name: "Les Trésors d'Ulysse", logo: '/partners/tresors-d-ulysse-logo.jpg', route: '/partenaires/tresors-d-ulysse' },
  { name: 'MFEC', logo: '/partners/mfec.png', route: '/partenaires/mfec' },
];

function useCompactPartners() {
  const [on, setOn] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-width: 992px)').matches
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 992px)');
    const update = () => setOn(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  return on;
}

type Props = {
  /** Classes section (ex. lp-partners--scroll-teaser). */
  className?: string;
  /** Clé i18n label — défaut landingV2.partners.label */
  labelKey?: string;
};

/**
 * Bandeau « Ils nous font confiance » — marquee ≤992, grille desktop.
 */
export default function MarketingPartnersStrip({
  className = 'lp-partners',
  labelKey = 'landingV2.partners.label',
}: Props) {
  const { t } = useTranslation('marketing');
  const compact = useCompactPartners();

  return (
    <section className={className}>
      <div
        className="lp-partners__inner"
        style={{
          background: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(12px)',
          borderRadius: '32px',
          padding: '32px 50px',
          border: '1px solid rgba(165, 118, 92, 0.2)',
          boxShadow: '0 30px 60px rgba(165,118,92,0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
        }}
      >
        <span
          className="lp-partners__label"
          style={{
            color: '#A5765C',
            opacity: 1,
            fontWeight: 900,
            fontSize: '11px',
            letterSpacing: '0.2em',
            background: 'rgba(165,118,92,0.1)',
            padding: '6px 16px',
            borderRadius: '100px',
            marginBottom: '4px',
          }}
        >
          {t(labelKey)}
        </span>
        <div
          className={compact ? 'lp-partners__logos lp-partners__logos--marquee' : 'lp-partners__logos'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '48px',
            flexWrap: 'wrap',
          }}
        >
          {compact ? (
            <div className="lp-partners__marquee-track">
              {[...MARKETING_PARTNERS, ...MARKETING_PARTNERS].map((p, i) => {
                const ghost = i >= MARKETING_PARTNERS.length;
                return (
                  <ProMarketingLink
                    key={`${p.name}-${i}`}
                    to={p.route}
                    className="lp-partners__link"
                    aria-label={ghost ? undefined : p.name}
                    aria-hidden={ghost || undefined}
                    tabIndex={ghost ? -1 : undefined}
                  >
                    <img
                      src={p.logo}
                      alt={ghost ? '' : p.name}
                      className="lp-partners__logo"
                      loading="lazy"
                    />
                  </ProMarketingLink>
                );
              })}
            </div>
          ) : (
            MARKETING_PARTNERS.map((p) => (
              <ProMarketingLink key={p.name} to={p.route} className="lp-partners__link" aria-label={p.name}>
                <img src={p.logo} alt={p.name} className="lp-partners__logo" loading="lazy" />
              </ProMarketingLink>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
